import { parseUrl, stringifyUrl } from 'query-string';

import { getYandexMetricsId } from 'shared/lib/getYandexMetricsId';

type Params = {
  googleAnalyticId: string;
  yandexMetricsId: string;
  bankName: string;
  offerName: string;
  productName: string;
  userId?: string;
  pagePath?: string;
  source?: string;
  calcId?: string;
  trafficSourceAsUtmURIString: string;
  uuid?: string;
  extraQuery?: Record<string, unknown>;
};

/** Обогащает параметрами url для статистики */
export const enrichPixel = (baseUrl: string | undefined, data: Params) => {
  if (!baseUrl) {
    return '';
  }

  const {
    source = 'creditselection',
    googleAnalyticId,
    yandexMetricsId,
    pagePath: aff_sub2 = typeof window !== 'undefined' ? window.location.pathname : undefined,
    offerName,
    bankName,
    productName,
    calcId,
    userId: aff_unique1,
    trafficSourceAsUtmURIString,
    uuid,
    extraQuery,
  } = data;

  const affSubGoogle = `ga_${(googleAnalyticId || '').split('.').slice(-2).join('.')}`;

  let affSubYandex = '';
  if (yandexMetricsId !== '') {
    affSubYandex = `ym_${yandexMetricsId}`;
  } else {
    const yandexIdFromPath = getYandexMetricsId(aff_sub2 || '');
    if (yandexIdFromPath) {
      affSubYandex = `ym_${yandexIdFromPath}`;
    }
  }

  const { url, query } = parseUrl(baseUrl);

  const params = {
    ...query,
    source,
    aff_sub: `${affSubGoogle}${affSubYandex ? `|${affSubYandex}` : ''}`,
    aff_sub2,
    aff_sub3: trafficSourceAsUtmURIString,
    aff_sub4: `${bankName}|${offerName}`,
    aff_sub5: `${productName}${calcId ? `|calc_id=${calcId}` : ''}${uuid ? `|uuid=${uuid}` : ''}`,
    aff_unique1,
    ...extraQuery,
  };

  return stringifyUrl({ url, query: params });
};
